import { render, staticRenderFns } from "./FromStageStandingTournament.vue?vue&type=template&id=3e4d119e&scoped=true"
import script from "./FromStageStandingTournament.vue?vue&type=script&lang=js"
export * from "./FromStageStandingTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d119e",
  null
  
)

export default component.exports